import React from 'react'
import { XIcon, WarningIcon } from '@phosphor-icons/react'

const GlobalBanner = ({ message, onClose, type = 'info' }) => {
  const getBorderColor = () => {
    switch (type) {
      case 'warning':
        return 'border-tertiary-warning'
      case 'error':
        return 'border-tertiary-error'
      case 'success':
        return 'border-tertiary-success'
      default:
        return 'border-brand-green'
    }
  }

  return (
    <div
      className={`bg-background-dark border ${getBorderColor()} border-solid rounded-default`}
    >
      <div className="flex items-center overflow-clip rounded-[inherit]">
        <div className="flex gap-3 grow items-center p-4">
          <div className="flex flex-col gap-3 grow items-start justify-center px-1 py-1.5">
            <div className="flex gap-3 items-center w-full">
              <WarningIcon
                size={19}
                weight="fill"
                className="text-brand-green shrink-0"
              />
              <p className="font-nunito font-normal italic leading-6 text-2xs text-white">
                {message}
              </p>
            </div>
          </div>
          {onClose && (
            <button
              onClick={onClose}
              className="shrink-0 w-6 h-6 flex items-center justify-center text-white hover:opacity-80 transition-opacity"
              aria-label="Close banner"
            >
              <XIcon size={16} weight="bold" />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default GlobalBanner
